<template>
  <Popup
    v-model:show="addressStore.visible"
    teleport="body"
    class="address-dialog"
  >
    <div class="decoration">
      <img
        src="@/assets/offer/address-header.svg"
        alt=""
      >
    </div>
    <!-- 关闭按钮 -->
    <img
      @click="onCloseDialog"
      class="close-icon"
      src="@/assets/images/close-icon.svg"
      alt=""
    >

    <div class="content">
      <div class="title">
        Add shipping address to help us build your delivery posting
      </div>
      <div
        v-if="isValidAddress"
        class="invalid-address"
      >
        <div class="invalid-address-l">
          <img
            src="@/assets/images/error-address.svg"
            alt=""
          >
          The logistics cannot be delivered at the moment. Please contact customer service for more information!
        </div>
        <div
          @click="handleContact"
          class="contact-us"
        >
          Contact us
        </div>
      </div>
      <!-- 地址识别 -->
      <Intelligent
        :address-type="addressStore.addressType"
        @parse-success="handleParseAddress"
      />

      <!-- 表单 -->
      <Form ref="formRef" />
    </div>
    <div class="footer">
      <Button
        @click="onCloseDialog"
        class="button"
      >
        Cancel
      </Button>
      <Button
        @click="handleSave"
        class="button"
        :loading="loading"
        type="primary"
      >
        Save
      </Button>
    </div>
  </Popup>
</template>

<script setup>
import { ref } from 'vue'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { fetchData } from '@/utils/fetch'
import { usePlugin } from '@/hooks/usePlugin'
import { useContactApp } from '@/hooks/useContactApp'
import { useAddressStore } from '@/pinia/address'
import Intelligent from './components/Intelligent.vue'
import Form from './components/Form.vue'
import { Popup } from '../Popup'
import { Button } from '../Button'

const addressStore = useAddressStore()

const { contactUs } = useContactApp()

const { $toast } = usePlugin()

const formRef = ref(null)

const loading = ref(false)

const isValidAddress = ref(false)

watch(() => addressStore.visible, (value) => {
  if (value) {
    document.documentElement.scrollTop = 0

    gaAnalytics('p_address_edit_page_view', 'p_address_edit_page_view')
    buriedPointUtil({ eventId: 'PAE501', others: { addressType: addressStore.addressType } })
  }
})

const handleParseAddress = (data) => {
  buriedPointUtil({ eventId: 'PAE203', others: { addressType: addressStore.addressType } })

  formRef.value.fillInfo(data)
}

const onCloseDialog = () => {
  addressStore.close()
}

const handleContact = () => {
  contactUs()
}

const handleSave = () => {
  formRef.value.validate().then(async res => {
    loading.value = true
    const { code, msg } = await fetchData('/appb/b2b/Logistics/checkSupportDeliveryByAddress', {
      method: 'POST',
      body: JSON.stringify(res)
    })
    loading.value = false

    if (code !== 200) {
      isValidAddress.value = true
      buriedPointUtil({ eventId: 'PAE401', others: { addressType: addressStore.addressType } })
      $toast(msg, { type: 'error' })
      return
    }

    buriedPointUtil({ eventId: 'PAE201', others: { addressType: addressStore.addressType } })
    gaAnalytics('p_address_save_success', 'p_address_save_success')
    $toast('Address saved successfully', { type: 'success' })

    addressStore.updateAddress(res)
    addressStore.close()
  })
}
</script>

<style lang='less'>
.address-dialog {
  width: 874px;
  background-color: white;

  .decoration {
    height: 20px;
    img {
      width: 100%;
    }
  }

  .close-icon {
    position: absolute;
    top: 36px;
    right: 16px;
    cursor: pointer;
    width: 28px;
    height: 28px;
  }

  .content {
    margin-top: 24px;
    padding: 0 32px;
    height: 528px;
    overflow-y: scroll;

    .title {
      color: #232323;
      font-size: 20px;
      font-family: mon-700;
    }

    .invalid-address {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      margin-top: 16px;
      height: 40px;
      background-color: #FCF2F5;
      color: #7A0505;
      font-size: 11px;
      font-family: mon-500;
      .invalid-address-l {
        display: flex;
        align-items: center;
        gap: 8px;
        img {
          width: 16px;
        }
      }

      .contact-us {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        text-decoration: underline;
        &:hover {
          color: var(--link-hover-color);
          cursor: pointer;
        }
      }
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: end;
    height: 88px;
    padding: 0 24px;
    border-top: 1px solid #ebf1f5;

    .button {
      width: 180px;
      margin-left: 16px;
    }
  }
}
</style>
